import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from "@fortawesome/free-solid-svg-icons";
import { T } from "react-translator-component";

const WhatsappContactLink = ({ url, title = null }) => {   

    return (
          <a href={url} target="_blank">
            <div className="px-3 py-2" style={{ borderTop: "1px solid #DDD", background: "#FFF" }}>
              <div className="d-block text-center d-flex" style={{ gap: 15, justifyContent: "flex-start", alignItems: "center" }}>
                <div style={{ minWidth: 35, height: 35, padding: 2, borderRadius: "50%", background: "#CCC", textAlign: "center", display: "flex", justifyContent: "center", alignItems: "center" }}>
                  <FontAwesomeIcon icon={faComment} color="#FFF" style={{ fontSize: 14 }} />
                </div>
                <div className="text-left">
                  <p className="mb-0">
                    <b style={{ color: "#555555" }}>{title ?? T("status.contact")}</b>
                  </p>
                  <p className="mb-0" style={{ fontSize: 14, color: "#888" }}>
                    {T("status.contact_description")}
                  </p>
                </div>
              </div>
            </div>
          </a>

    )
}

export default WhatsappContactLink